/* ==========================================================================
   FERO — About page cloth
   A sheet of vertical lines drawn on a canvas behind the statement. The folds
   are a displacement field: each line is pushed sideways by a few creases, and
   the main crease follows the pointer, leaning the way the pointer travels.
   Loaded only by sections/main-about.liquid.
   ========================================================================== */
(function () {
  var cv = document.getElementById('cloth');
  if (!cv || !cv.getContext) return;
  var ctx = cv.getContext('2d');
  var box = document.querySelector('.about-box');
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  var W = 0, H = 0, G = null, X = null;
  var px = null, py = null;              /* pointer in canvas px; null when absent */
  var mx = 0, my = 0, ang = 0, speed = 0; /* the crease, eased toward the pointer */
  var visible = true, running = false, start = performance.now();

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  /* ---------- geometry ---------- */
  /* The sheet is centred on the white block and always wider than it, so the
     lines show on every side of the statement rather than only above and below. */
  function layout() {
    var r = cv.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = r.width; H = r.height;
    if (!W || !H) return false;
    cv.width = Math.round(W * dpr);
    cv.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    var b = box ? box.getBoundingClientRect() : { left: r.left + W / 2, top: r.top + H / 2, width: 0, height: 0 };
    var cx = b.left - r.left + b.width / 2;
    var cy = b.top - r.top + b.height / 2;
    var h = H * 0.84;
    var w = Math.min(W * 0.92, Math.max(h * 0.74, b.width * 1.36));
    var n = Math.max(24, Math.round(w / (W < 700 ? 8 : 10)) + 1);
    var step = 4;

    G = {
      cx: cx, cy: cy, w: w, h: h,
      x0: cx - w / 2, y0: cy - h / 2,
      n: n, gap: w / (n - 1), step: step,
      ytop: cy - h / 2 - h * 0.08,
      m: Math.ceil(h * 1.16 / step) + 2
    };
    X = new Float32Array(G.n * G.m);
    if (!running) { var p = rest(0); mx = p.x; my = p.y; }
    return true;
  }

  /* the ragged hems: top and bottom ends of each line, u = 0..1 across */
  function hemTop(u) {
    return G.y0 + G.h * (0.035 * Math.sin(u * 5.3 + 0.4) + 0.02 * Math.sin(u * 12.1 + 1.3) + 0.03 * u);
  }
  function hemBot(u) {
    return G.y0 + G.h * (1 + 0.02 * Math.sin(u * 4.1 + 2.2) + 0.015 * Math.sin(u * 9.7 + 0.7) - 0.02 * u);
  }
  /* the sheet's own sway, which is what makes its left and right edges uneven */
  function sway(t, u) {
    return G.w * (0.02 * Math.sin(t * 6.8 + 0.6) * (1 - u) +
                  0.018 * Math.sin(t * 5.2 + 2.1) * u +
                  0.007 * Math.sin(t * 13 + u * 3));
  }

  /* where the crease rests when nothing is pointing: up and to the left of the
     statement, so its long diagonal runs out from behind the white block
     instead of being hidden by it. It drifts slowly so the cloth never freezes. */
  function rest(time) {
    return {
      x: G.cx - G.w * 0.22 + G.w * 0.05 * Math.sin(time * 0.25),
      y: G.cy - G.h * 0.24 + G.h * 0.04 * Math.sin(time * 0.18)
    };
  }

  /* A fold is a line across the sheet (centre, lean theta from vertical). A
     point's offset across that line, d, pushes it sideways by A·d·e^(−d²),
     tapered along the fold's length — lines bunch on the fold and fan out at
     its shoulders, which is what reads as a crease. */
  function fold(x, y, theta, s, L, A) {
    var ax = Math.sin(theta), ay = Math.cos(theta);
    return { x: x, y: y, ax: ax, ay: ay, nx: ay, ny: -ax, s: s, L: L, A: A };
  }
  function push(x, y, f) {
    var ox = x - f.x, oy = y - f.y;
    var d = (ox * f.nx + oy * f.ny) / f.s;
    var l = (ox * f.ax + oy * f.ay) / f.L;
    return f.A * d * Math.exp(-d * d - l * l);
  }

  /* ---------- one frame ---------- */
  function frame(now) {
    if (!G) return;
    var time = (now - start) / 1000;
    var p = rest(time);
    var tx = px == null ? p.x : clamp(px, G.x0 - G.w * 0.1, G.x0 + G.w * 1.1);
    var ty = py == null ? p.y : clamp(py, G.y0 - G.h * 0.1, G.y0 + G.h * 1.1);

    var pmx = mx, pmy = my;
    mx += (tx - mx) * (still ? 1 : 0.07);
    my += (ty - my) * (still ? 1 : 0.07);
    var vx = mx - pmx, vy = my - pmy;
    speed += (Math.abs(vx) + Math.abs(vy) - speed) * 0.08;
    /* the crease leans after the pointer, the way cloth drags behind a hand */
    ang += (clamp(vx * 0.035, -0.55, 0.55) - ang) * 0.06;

    var s0 = G.w * 0.11, s1 = G.w * 0.15, s2 = G.w * 0.12;
    var folds = [
      fold(mx, my, 0.3 + ang, s0, G.h * 0.55, -(0.85 + Math.min(speed * 0.02, 0.3)) * s0),
      fold(G.cx - G.w * 0.27 - (mx - G.cx) * 0.08 + G.w * 0.02 * Math.sin(time * 0.3),
           G.cy - G.h * 0.12 - (my - G.cy) * 0.06, -0.25, s1, G.h * 0.5, 0.32 * s1),
      fold(G.cx + G.w * 0.26 - (mx - G.cx) * 0.06,
           G.cy + G.h * 0.2 + G.h * 0.02 * Math.sin(time * 0.23 + 1), 0.55, s2, G.h * 0.34, -0.3 * s2)
    ];

    /* Row by row, so neighbouring lines can be kept apart: however the folds
       add up, a line never crosses the one to its left. */
    var n = G.n, m = G.m, step = G.step, minGap = G.gap * 0.18;
    for (var j = 0; j < m; j++) {
      var y = G.ytop + j * step, t = (y - G.y0) / G.h, prev = -1e9;
      for (var i = 0; i < n; i++) {
        var u = i / (n - 1), x = G.x0 + u * G.w;
        var v = x + sway(t, u) + push(x, y, folds[0]) + push(x, y, folds[1]) + push(x, y, folds[2]);
        if (v < prev + minGap) v = prev + minGap;
        X[j * n + i] = v;
        prev = v;
      }
    }

    ctx.clearRect(0, 0, W, H);
    ctx.strokeStyle = getComputedStyle(cv).color;
    ctx.lineWidth = W < 700 ? 1 : 1.25;
    ctx.lineJoin = 'round';
    ctx.beginPath();
    for (var k = 0; k < n; k++) {
      var uu = k / (n - 1);
      var top = hemTop(uu), bot = hemBot(uu);
      var jt = (top - G.ytop) / step, jb = (bot - G.ytop) / step;
      var a = Math.floor(jt), c = Math.floor(jb);
      ctx.moveTo(X[a * n + k] + (X[(a + 1) * n + k] - X[a * n + k]) * (jt - a), top);
      for (var r = a + 1; r <= c; r++) ctx.lineTo(X[r * n + k], G.ytop + r * step);
      ctx.lineTo(X[c * n + k] + (X[(c + 1) * n + k] - X[c * n + k]) * (jb - c), bot);
    }
    ctx.stroke();
  }

  /* ---------- running ---------- */
  function loop(now) {
    if (!visible || still) { running = false; return; }
    frame(now);
    requestAnimationFrame(loop);
  }
  function kick() {
    if (running || !visible || still || !G) return;
    running = true;
    requestAnimationFrame(loop);
  }
  function redraw() {
    if (layout()) { if (still) frame(performance.now()); else kick(); }
  }

  function aim(clientX, clientY) {
    var r = cv.getBoundingClientRect();
    px = clientX - r.left;
    py = clientY - r.top;
    if (still) frame(performance.now());
  }
  addEventListener('pointermove', function (e) { aim(e.clientX, e.clientY); }, { passive: true });
  addEventListener('touchmove', function (e) {
    if (e.touches[0]) aim(e.touches[0].clientX, e.touches[0].clientY);
  }, { passive: true });
  /* pointer gone: the crease drifts home instead of freezing where it was left */
  document.documentElement.addEventListener('mouseleave', function () { px = py = null; });
  addEventListener('touchend', function () { px = py = null; }, { passive: true });

  /* stop drawing while the cloth is scrolled away or the tab is hidden */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      kick();
    }).observe(cv);
  }
  /* the statement can change height as fonts arrive; the sheet is sized off it */
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(redraw);
    ro.observe(cv);
    if (box) ro.observe(box);
  } else {
    addEventListener('resize', redraw);
  }
  redraw();
})();
